import { AnnouncementModalLayout, Text } from '@wix/design-system';
import React, { useEffect } from 'react';
import AdvancedOauthCompleteInstallationIllustration from '../../assets/images/advanced-oauth-complete-installation.svg';
import { reportModalCtaClick, reportModalShown, reportModalUnmounted } from '../../bi/bi';
import { Modals } from '../../types';
import { useInstallerContext } from '../../context/InstallerContext';
import { getIsBulkInstallTriggered } from '../../selectors/bulk-installer-triggered';
import { useModalsAndWindow } from '../../context/ModalsAndWindowContext';
import { useTranslation } from '@wix/wix-i18n-config';
export const GoToOtherTabModal = () => {
  const {
    t
  } = useTranslation();
  const {
    newWindowHandlers: {
      closeWindow
    }
  } = useModalsAndWindow();
  const {
    onInstallationCompleted
  } = useInstallerContext();
  useEffect(() => {
    reportModalShown(Modals.goToOtherTab);
    return () => {
      reportModalUnmounted(Modals.goToOtherTab, getIsBulkInstallTriggered());
    };
  }, []);
  const onCloseButtonClick = () => {
    reportModalCtaClick({
      ctaName: 'close',
      modalType: Modals.goToOtherTab
    });
    if (!getIsBulkInstallTriggered()) {
      closeWindow();
      onInstallationCompleted({
        status: 'CANCELED'
      });
    }
  };
  return /*#__PURE__*/React.createElement(AnnouncementModalLayout, {
    dataHook: "advanced-oauth-complete-installation-modal",
    onCloseButtonClick: onCloseButtonClick,
    title: t('advanced-oauth-complete-installation-modal.title'),
    illustration: /*#__PURE__*/React.createElement(AdvancedOauthCompleteInstallationIllustration, null)
  }, /*#__PURE__*/React.createElement(Text, null, t('advanced-oauth-complete-installation-modal.text')));
};
//# sourceMappingURL=GoToOtherTabModal.js.map